"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVehicleAllowedOldByCountry = isVehicleAllowedOldByCountry;
const COUNTRY_CODES_FOR_ALLOW_OLD = [
    "na", // Namibia
    "za", // South Africa
    "ug", // Uganda
    "ke", // Kenya
    "bw", // Botswana
    "bz", // Belize
    "cu", // Cuba
    "jm", // Jamaica
    "ci", // Cote d'Ivoire
    "gh", // Ghana
    "bi", // Burundi
    "rw", // Rwanda
    "am", // Armenia
    "az", // Azerbaijan
    "ge", // Georgia
    "lk", // Sri Lanka
];
const COUNTRY_CODES_FOR_ALLOW_OLD_VANS = [
    "al", // Albania
    "bg", // Bulgaria
];
function isVehicleAllowedOldByCountry(countryCode, passengerCount) {
    if (COUNTRY_CODES_FOR_ALLOW_OLD.includes(countryCode)) {
        return true;
    }
    if (COUNTRY_CODES_FOR_ALLOW_OLD_VANS.includes(countryCode)) {
        return passengerCount >= 5;
    }
    return false;
}
//# sourceMappingURL=isVehicleAllowedOldByCountry.js.map